import component from "./GenderRadio";

export default component;
